/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Event_LabelInputs */

const en_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const fr_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement`)
};

const de_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis`)
};

const it_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const ru_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие`)
};

const es_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const zh_cn2_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件`)
};

const ja_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント`)
};

const hi_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन`)
};

const pt_pt2_image_export_preview_event_label = /** @type {(inputs: Image_Export_Preview_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Image_Export_Preview_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_event_label = /** @type {((inputs?: Image_Export_Preview_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_event_label(inputs)
	if (locale === "de") return de_image_export_preview_event_label(inputs)
	if (locale === "it") return it_image_export_preview_event_label(inputs)
	if (locale === "ru") return ru_image_export_preview_event_label(inputs)
	if (locale === "es") return es_image_export_preview_event_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_event_label(inputs)
	if (locale === "ja") return ja_image_export_preview_event_label(inputs)
	if (locale === "hi") return hi_image_export_preview_event_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_event_label(inputs)
	return en_image_export_preview_event_label(inputs)
});